import { Component, ViewChild, ViewChildren, OnInit, QueryList, ElementRef, AfterViewInit, Inject, OnChanges, SimpleChanges } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AbstractDetail } from '../../../models/abstract/abstract-detail.model';
import { Protocol } from '../../../models/protocol/protocol.model';
import { ProtocolSubmissionRule } from '../../../models/protocol/protocolSubmissionRule.model';
import { RuleActionType } from '../../../models/protocol/ruleActionType.model';
import { Section } from '../../../models/evaluation/section.model';
import { Tracker } from '../../../models/evaluation/tracker.model';
import { Evaluation } from '../../../models/evaluation/evaluation.model';
import { Note } from '../../../models/evaluation/note.model';
import { Roles, SubmissionType, AbstractStatus, AbstractProtocolStatusEnum, WorkflowTaskTypes, StageTypeEnum } from '../../../models/enums';

import { SectionItemColumnDescription } from '../../../models/evaluation/sectionItemColumnDescription.model';
import { AbstractService } from '../../../services/abstract.service';
import { NoteService } from '../../../services/note.service';
import { ProtocolService } from '../../../services/protocol.service';
import { CodingService } from '../../../services/coding.service';
import { AccountService } from "../../../services/account.service";
import { AuthService } from "../../../services/auth.service";
import { AlertService, DialogType, MessageSeverity } from '../../../services/alert.service';
import { ErrorService } from '../../../services/error.service';
import { Utilities } from '../../../services/utilities';

import { ProtocolInfoBottomSheetComponent } from '../../bottom-sheet/protocol-info-bottom-sheet/protocol-info-bottom-sheet.component';
import { SimpleBottomSheetComponent } from '../../bottom-sheet/simple-bottom-sheet/simple-bottom-sheet.component';
import { AbstractBottomSheetComponent } from '../../bottom-sheet/abstract-bottom-sheet/abstract-bottom-sheet.component';
import { QuickNoteDialogComponent } from '../../dialogs/quick-note-dialog/quick-note-dialog.component';
import { DecisionBottomSheetComponent } from '../../bottom-sheet/decision-bottom-sheet/decision-bottom-sheet.component';
import { Observable } from 'rxjs';
import { PACTHubService } from '../../../services/pacthub.service';
import { CommonModule, NgClass } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { FormsModule } from '@angular/forms';

////[Notes:BJL_2023-06-24]: debugging
////Attempted to return any errors from subscribe to console
////
//import { tap } from 'rxjs/operators';

//export enum RxJsLoggingLevel {
//  TRACE,
//  DEBUG,
//  INFO,
//  ERROR
//}

//let rxjsLoggingLevel = RxJsLoggingLevel.INFO;

//export function setRxJsLoggingLevel(level: RxJsLoggingLevel) {
//  rxjsLoggingLevel = level;
//}


//export const debug = (level: number, message: string) =>
//  (source: Observable<any>) => source
//    .pipe(
//      tap(val => {

//        if (level >= rxjsLoggingLevel) {
//          console.log(message + ': ', val);
//        }
//      })
//    );


@Component({
  selector: 'app-code-evaluation',
  templateUrl: './code-evaluation.component.html',
  styleUrls: ['./code-evaluation.component.css'],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule
  ]
})
export class CodeEvaluationComponent implements OnInit, OnChanges {

  activeRole: Roles;
  activeTeamId: number = 0;

  protocolId: number = 0;
  abstractId: number = 0;
  submissionId: number = 0;
  evaluationTypeId: number = 0;
  evaluation: Evaluation = new Evaluation();
  loadingIndicator: boolean = false;
  sectionItemColumnDescription: any;
  cellStatus: Array<boolean> = [];
  counter: number = 0;
  uiTracker: Array<Tracker> = [];
  formTitle: string = "";
  watchConsensusVisible: boolean = false;
  watchConsensusEnabled: Boolean = false;
  startConsensusVisible: boolean = false;
  startConsensusMergeVisible: boolean = false;


  isLoading: boolean = false;

  submissionTypeId: number = 1; //1 Coder Submission


  submissionProcessing: boolean = false;
  isSubmitted: boolean = false;
  isSubmissionView: boolean = false;
  isEvaluationCompleted: boolean = false;

  isConsensusReady: boolean = false;
  isConsensus: boolean = false;

  isConsensusMerge: boolean = false;

  isWatchConsensus: boolean = false;

  userName: string;

  codingSubmittable: boolean = false;

  isDriving: boolean | null = null;
  currentPhase: string = ""; // Determining the current phase of the evaluation

  noteText: string;
  note: Note = new Note();

  recommendedForODPReview: boolean = false;
  recommendedForODPAdjudication: boolean = false;

  //odpReviewDisabled: boolean = false;
  //adjudicationDisabled: boolean = false;

  joinedConsensus: boolean = false;

  submittedMessage: string = "";

  teamMembers: string = "";

  constructor(private protocolService: ProtocolService,
    private codingService: CodingService,
    private noteService: NoteService,
    private bottomSheet: MatBottomSheet,
    private abstractService: AbstractService,
    private alertService: AlertService,
    private accountService: AccountService,
    private authService: AuthService,
    private errorService: ErrorService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    public dialog: MatDialog,
    public hub: PACTHubService) {
  }


  ngOnChanges(changes: SimpleChanges): void {
    if (changes['evaluation']) {
      this.evaluatePhase();
    }
  }

  public ngOnInit(): void {
    if (this.authService.isSessionExpired) {
      console.log(`REDIRECT LOGIN`);
      this.router.navigateByUrl('/account/login');
    } else {
      this.activeRole = this.accountService.GetActiveRole();
      if (this.accountService.GetActiveTeam()) { 
        this.activeTeamId = this.accountService.GetActiveTeam().teamId;
      }

      this.protocolId = this.activeRoute.snapshot.params['protocolId'];
      this.abstractId = this.activeRoute.snapshot.params['abstractId'];
      this.submissionId = this.activeRoute.snapshot.params['submissionId'];
    }
  }

  public ngOnDestroy(): void {
    if (this.joinedConsensus)
      this.hub.leaveConsensus(this.evaluation.evaluationId);
  }

  ngAfterViewInit() {

    if (this.protocolId != null && this.protocolId != 0 && this.abstractId != null && this.abstractId != 0) {
      this.alertService.showMessage("Loading", "Protocol Data", MessageSeverity.wait);
      this.LoadViewData(this.abstractId, this.protocolId);
    }
    else {
      if (this.submissionId != null && this.submissionId != 0) {
        this.ViewEvaluation(this.submissionId);
      }
      else {
        this.router.navigateByUrl('/home/actions');
      }
    }
  }

  ///ViewEvaluation (and abstractService.getEvaluationSubmissionData) = read-only coding form for consensus/comparison watchers
  public ViewEvaluation(evaluationId) {
    this.alertService.startLoadingMessage();
    this.loadingIndicator = true;

    this.abstractService.getEvaluationSubmissionData(evaluationId, this.activeRole)
      ////[Notes:BJL_2023-06-24]: debugging
      //// Attempted to return any errors from subscribe to console
      ////
      ////.pipe(
      ////  debug(RxJsLoggingLevel.DEBUG, "getEvaluationSubmissionData (Submission in AbstractController.cs): ")
      ////)
      .subscribe({
        next: evaluation => {
          this.evaluation = evaluation;
          this.evaluatePhase();
          this.recommendedForODPReview = evaluation.isRecommendedForReview;
          this.recommendedForODPAdjudication = evaluation.isRecommendedForAdjudication;
          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
          this.isSubmitted = true;
          this.isSubmissionView = true;
          this.teamMembers = this.evaluation.teamMembers;
          /// [NOTES: BJL_2025-04-03]: added status AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B - this is the status when Westat/ML Comparison is ready/inprogress
          if (this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A || this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B || this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A || this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B) {
            this.joinConsensusPresence(true);
            this.joinedConsensus = true;
          }

          //this.odpReviewDisabled = true;
        },
        ////[Notes:BJL_2023-06-24]: debugging
        //// Attempted to return any errors from subscribe to console
        ////
        ////console.error
        error: (error) => {
          this.loadingIndicator = false;
          this.alertService.stopLoadingMessage();
          this.alertService.showStickyMessage("Loading Abstract Data Issue", `"${Utilities.getHttpResponseMessage(error)}"`,
            MessageSeverity.error, error);
        }
      });
  }

  ///LoadViewData and abstractService.getFullAbstractForEvaluation = editable coding form for individual coders and consensus/comparison drivers
  public LoadViewData(abstractId, protocolId, isWatch = false) {
    this.loadingIndicator = true;
    //this.userName = this.userName;
    //console.log('userName: {username} ' + this.userName);
    //console.log('fullName: ' + this.authService.currentUser.fullName);
    this.abstractService.getFullAbstractForEvaluation(abstractId, protocolId, this.accountService.GetActiveRole(), this.accountService.GetActiveTeam().teamId)
      .subscribe({
        next: evaluation => {
          this.evaluation = evaluation;
          this.evaluatePhase();
          this.isSubmitted = false;
          this.recommendedForODPReview = evaluation.isRecommendedForReview;
          this.recommendedForODPAdjudication = evaluation.isRecommendedForAdjudication;
          this.teamMembers = this.authService.currentUser.fullName;
          /// Set form titles for consensus/comparison watchers
          /// [NOTES: BJL_2025-04-03]: added status AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B - this is the status when Westat/ML Comparison is ready/inprogress
          var watcherFormTitle = "";
          switch (this.evaluation.abstractStatusId) {
            case AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A:
              watcherFormTitle = "QC Coding Consensus [W2]";
              break;
            case AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B:
              watcherFormTitle = "QC Comparison with ML [W3]";
              break;
            case AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A:
              watcherFormTitle = "Reconcilation Coding Consensus [O2]";
              break;
            case AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B:
              watcherFormTitle = "Reconciliation Comparison with QC-Consensus and ML [O3]";
              break;
          }
          //if (this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A || 
          //  this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B || 
          //  this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A || 
          //  this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B) {
          if (watcherFormTitle != "") {
            if (this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B ||
              this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B) {
              this.isConsensusMerge = true;
            } else
              this.isConsensus = true;
            if (!this.joinedConsensus) {
              this.joinConsensusPresence();
              this.joinedConsensus = true;
              //if (!isWatch)
              //  this.hub.getRequestedConsensusState().subscribe((request) => { if (request) { this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions); } }, (error) => { console.log(error); });
            }

            if (this.evaluation.consensusStartedByYou) {
              console.log("YOU own consensus");
              this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, "Watching " + watcherFormTitle + " - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : ""); //{username} replacement comes from PACTHub.cs BroadcastConsensusState line 157
              this.hub.getRequestedConsensusState().subscribe({
                next: (request) => {
                  if (request)
                    this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, "Watching " + watcherFormTitle + " - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : "");
                }, error: (error) => {
                  console.log(error);
                }
              });
            }
            //else {
            //  this.hub.broadcastRequestConsensusState(this.evaluation.evaluationId);
            //}
          }

          if (!this.protocolId || this.protocolId == null) {
            this.protocolId = evaluation.protocolId;
          }
          if (!this.abstractId || this.abstractId == null) {
            this.abstractId = evaluation.abstractId;
          }

          this.alertService.stopLoadingMessage();
          this.loadingIndicator = false;
        }, error: (error: HttpErrorResponse) => {
          this.loadingIndicator = false;
          this.alertService.stopLoadingMessage();

          const errorResult = Utilities.getHttpResponseMessage(error);

          const submissionId = error.error.object && error.error.object.hasOwnProperty('submissionId') ?
            +error.error.object['submissionId'] : -1;
          const abstractIdForRedirect = error.error.object && error.error.object.hasOwnProperty('abstractIdForRedirect') ?
            +error.error.object['abstractIdForRedirect'] : -1;

          if (errorResult != null && submissionId > 0) {
            this.router.navigateByUrl('/evaluation/view/' + submissionId);
            return;
          }

          if (errorResult != null && abstractIdForRedirect > 0) {
            const message = 'A team member has already opened another abstract for coding. ' +
              'Would you like to be redirected to the abstract\'s view page?';

            this.openDecisionBottomSheet('Other opened abstract for coding', message).subscribe(isOk => {
              const url = isOk ? `/abstract/view/${abstractIdForRedirect}` : '/home/actions';
              this.router.navigateByUrl(url);
            });

            return;
          }

          this.errorService.error = {
            title: 'Loading Abstract Data Issue',
            message: `"${errorResult}"`,
            error: error,
            severity: MessageSeverity.error
          };

          this.router.navigateByUrl('/home/actions');
        }
      });
  }




  public startConsensus(abstractId, protocolId) {
    if (this.submissionId != null && this.submissionId != 0) {
      this.router.navigateByUrl('/evaluation/code/' + abstractId + '/' + protocolId);
    }
    else {
      this.alertService.showMessage("Loading", "Consensus Data", MessageSeverity.wait);
      this.LoadViewData(abstractId, protocolId);

      this.isSubmitted = false;
      this.codingSubmittable = false;
      //this.recommendedForODPReview = false;
      this.isConsensusReady = false;
      this.isConsensus = true;
    }
  }

  public joinConsensusPresence(requestState?: boolean) {
    this.hub.joinConsensus(this.evaluation.evaluationId, requestState);
    this.joinedConsensus = true;

    if (this.evaluation.watchConsensusVisible) {
      this.hub.getConsensusStarted().subscribe({
        next: (result: Boolean) => {
          if (!this.isWatchConsensus)
            this.watchConsensusEnabled = result;
        }, error: (error) => {
          console.log(error);
        }
      });
    }
  }

  public startConsensusMerge(abstractId, protocolId) {
    this.alertService.showMessage("Loading", "Comparison Data", MessageSeverity.wait);

    this.LoadViewData(abstractId, protocolId);
  }

  public watchConsensus() {
    //this.LoadViewData(this.evaluation.abstractId, this.evaluation.protocolId, true);

    this.isSubmitted = false;
    this.codingSubmittable = false;
    //this.recommendedForODPReview = false;
    this.isConsensusReady = false;
    this.isConsensus = false;
    this.isWatchConsensus = true;

    this.evaluation.watchConsensusVisible = false;

    this.hub.getConsensusState().subscribe({
      next: (result: Array<Tracker>) => {
        //console.log("Updating consensus state");
        this.evaluation.submissions = result;
      }, error: (error) => {
        console.log(error);
      }
    });

    this.hub.getConsensusTitle().subscribe({
      next: (result: string) => {
        //console.log("Updating form title");
        this.evaluation.formTitle = result;

      }, error: (error) => {
        console.log(error);
      }
    });

    this.hub.getConsensusSubmittedMessage().subscribe({
      next: (result: string) => {
        //console.log("Updating submission message");
        this.submittedMessage = result;

        if (result && result.length > 0)
          window.scroll(0, 0);
      }, error: (error) => { }
    });

    this.hub.broadcastRequestConsensusState(this.evaluation.evaluationId);
  }

  openProtocolInformationWindow(protocol: Protocol, viewAnchor: string) {
    var pdfToOpen = protocol && protocol.protocolInformationFile && protocol.protocolInformationFile != ""
      ? protocol.protocolInformationFile : "ODP_Coding_Taxonomy_and_Protocol_v4_1_1.pdf";
    window.open(`../../../../assets/data/${pdfToOpen}#nameddest=${viewAnchor}`, "_blank");
  }

  openAbstractInformationWindow(abstractId: number) {
    window.open(`/#/abstract/view/${abstractId}/readonly`, '_blank');
  }

  openSimpleBottomSheet(sheetTitle: string, sheetText: string, event: Event): void {

    event.stopPropagation();

    this.bottomSheet.open(SimpleBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        sheetText: sheetText
      }
    });
  }

  openProtocolInfoBottomSheet(sheetTitle: string, protocol: Protocol, sectionsData: Array<Section>, event: Event): void {

    event.stopPropagation();

    this.bottomSheet.open(ProtocolInfoBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        protocolData: protocol,
        sectionData: sectionsData
      }
    });
  }

  openAbstractBottomSheet(abstract: any, notes: Note[]): void {
    //console.log(abstract)
    this.bottomSheet.open(AbstractBottomSheetComponent, {
      data: {
        abstract: abstract,
        notes: notes,
        evaluationId: this.evaluation.evaluationId,
        abstractProtocolId: this.evaluation.abstractProtocolId
      }
    });
  }

  public reset(): void {

    if (this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A || this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B || this.evaluation.abstractStatusId == AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A || this.evaluation.abstractStatusId == AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B) {
      this.alertService.showMessage("Loading", "Consensus Data", MessageSeverity.wait);
      this.LoadViewData(this.abstractId, this.protocolId);
    }
    else {
      this.codingSubmittable = false;
      for (let cell of this.evaluation.submissions) {

        //Enables disabled by rule cells
        cell.disabledByRule = false;
        cell.disabledByRuleId = null;

        //Unselects selected cells
        if (cell.selected == true) {
          cell.selected = false;
          cell.cssClassName = "";

          //Unselects and disables child cells
          let child = this.evaluation.submissions.find(x => x.parentSectionItemColumnDescriptionId == cell.sectionItemColumnDescriptionId);
          if (child != null) {
            child.disabled = !child.disabled;
            child.selected = false;
            child.cssClassName = "";
          }
        } else {
          cell.cssClassName = "itemCellActive";
          cell.disabled = false;
        }
      }
    }
  }

  //public reTraceTrackerForRules() {
  //  for (let tracker of this.evaluation.submissions) {
  //    //For "Then" Rule
  //    var cellRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.fromCell == tracker.id);
  //    if (cellRules.length > 0) {
  //      for (let rule of cellRules) {
  //        switch (rule.ruleActionType.command) {
  //          case "Then":
  //            this.executeThenEnabledAction(tracker, rule, true);
  //            break;
  //        }
  //      }
  //    }
  //  }
  //}

  public getCssClassName(sectionId: number, sectionItemId: number, sectionColumnId: number) {
    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    //console.log("Section Item Column Description Id: " + cellTracker.sectionItemColumnDescriptionId + ",Section Id:" + sectionId + ", Section Item Id:" + sectionItemId + ", Section Column Id:" + sectionColumnId)
    if (cellTracker != null) {
      if (cellTracker.disabled) {
        return "w-25 itemCellDisabled";
      }
      else {
        return "w-25 " + cellTracker.cssClassName;
      }
    }
  }

  public getUsersThatSelectedCell(sectionId: number, sectionItemId: number, sectionColumnId: number) {

    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    if (cellTracker != null) {
      return cellTracker.userSelectedTracker;
    }
    return null;
  }

  public makeVisibleUsersThatSelectedCell(sectionId: number, sectionItemId: number, sectionColumnId: number) {

    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    if (cellTracker != null) {
      cellTracker.usersThatSelectedCellVisible = !cellTracker.usersThatSelectedCellVisible;
    }
  }
  public areUsersThatSelectedCellVisible(sectionId: number, sectionItemId: number, sectionColumnId: number) {

    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    if (cellTracker != null) {
      return cellTracker.usersThatSelectedCellVisible;
    }
    return false;
  }

  public getUsersThatSelectedCellCount(sectionId: number, sectionItemId: number, sectionColumnId: number) {

    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    if (cellTracker != null && cellTracker.userSelectedTracker.length != 0) {
      return cellTracker.indicator;
    }
    return '';
  }

  public isCellSelected(sectionId: number, sectionItemId: number, sectionColumnId: number) {

    let cellTracker = this.getCellTracker(this.evaluation.submissions, sectionId, sectionItemId, sectionColumnId);
    if (cellTracker != null && cellTracker.selected) {
      //console.log("Section Item Column Description Id: " + cellTracker.sectionItemColumnDescriptionId + ",Section Id:" + sectionId + ", Section Item Id:" + sectionItemId + ", Section Column Id:" + sectionColumnId)
      return true;
    }
    return false;
  }

  public isRowNotVisible(sectionId: number, sectionItemId: number) {

    let cellsTracker = this.getRowTracker(this.evaluation.submissions, sectionId, sectionItemId);

    for (let cell of cellsTracker) {
      if (cell.parentSectionItemId != null) {
        let parentCellsTracker = this.getRowTracker(this.evaluation.submissions, sectionId, cell.parentSectionItemId);

        let shouldBeVisible = parentCellsTracker.filter(x => x.sectionId == sectionId && x.sectionItemId == cell.parentSectionItemId && (x.selected == true || x.indicator > 0))
        if (shouldBeVisible.length < 1) {
          return true;
        }
      }
    }
    return false;
  }

  public isChildRow(sectionId: number, sectionItemId: number) {

    let cellsTracker = this.getRowTracker(this.evaluation.submissions, sectionId, sectionItemId);

    for (let cell of cellsTracker) {
      if (cell.parentSectionItemId != null) {
        return true;
      }
    }
    return false;
  }

  public isEmptyParent(sectionId: number, sectionItemId: number) {

    let cellsTracker = this.getRowTracker(this.evaluation.submissions, sectionId, sectionItemId);

    for (let cell of cellsTracker) {
      if (cell.isEmptyParent == 1) {
        return true;
      }
    }
    return false;
  }

  public getCellTracker(uiTracker: Array<Tracker>, sectionId: number, sectionItemId: number, sectionColumnId: number): Tracker {
    let cellTracker = uiTracker.find(x => x.sectionId == sectionId && x.sectionColumnId == sectionColumnId && x.sectionItemId == sectionItemId)
    return cellTracker;
  }

  public getRowTracker(uiTracker: Array<Tracker>, sectionId: number, sectionItemId: number): Array<Tracker> {
    let cellsTracker = uiTracker.filter(x => x.sectionId == sectionId && x.sectionItemId == sectionItemId)
    return cellsTracker;
  }

  public cellClicked(sectionId: number, sectionItemId: number, sectionColumnId: number) {
    if (!this.isSubmitted && !this.isWatchConsensus) {
      let cellTracker = this.evaluation.submissions.find(x => x.sectionId == sectionId && x.sectionItemId == sectionItemId && x.sectionColumnId == sectionColumnId)
      if (cellTracker != null && !cellTracker.disabled && !cellTracker.disabledByRule) {
        //console.log("Section Id: " + (cellTracker.sectionId) + " Row Id:" + (cellTracker.sectionItemId) + " Column Id:" + (cellTracker.sectionColumnId))

        cellTracker.selected = !cellTracker.selected;
        cellTracker.cssClassName = cellTracker.selected ? "itemCellSelected" : "itemCellActive";
        if (cellTracker.selected) {
          cellTracker.unSelected = false;
        }
        //console.log(cellTracker)

        //var secCount = this.evaluation.codingUISections.length;

        //if (secCount == 7) {

        //Checks for validation rules if the cell has been cheked
        var cellRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.fromCell == cellTracker.id);
        if (cellRules.length > 0) {
          //here executes rules that has no dependencies
          let rules = cellRules.filter(r => r.runsIfRuleFailId == null);
          this.codingSubmittable = this.executeRules(rules, cellTracker);
        }
        else {
          var cellRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.toCell == cellTracker.id);
          if (cellRules.length > 0) {
            //here executes rules that has no dependencies
            let rules = cellRules.filter(r => r.runsIfRuleFailId == null);
            this.codingSubmittable = this.executeThenEnabledAction(cellTracker, rules.find(x => x.toCell == cellTracker.id), true);
          }
        }


        //} else {
        //  //Checks for validation rules if the cell has been cheked
        //  var cellRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.fromCell == cellTracker.id && psr.runsIfRuleSuccedId == null && psr.ruleActionType.decription != 'Master');
        //  if (cellRules.length > 0) {
        //    //here executes rules that has no dependencies
        //    let rules = cellRules.filter(r => r.runsIfRuleFailId == null);
        //    this.codingSubmittable = this.executeRules(rules, cellTracker);
        //  }
        //  else {
        //    var cellRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.toCell == cellTracker.id && psr.runsIfRuleSuccedId == null && psr.ruleActionType.decription != 'Master');
        //    if (cellRules.length > 0) {
        //      //here executes rules that has no dependencies
        //      let rules = cellRules.filter(r => r.runsIfRuleFailId == null);
        //      this.codingSubmittable = this.executeThenEnabledAction(cellTracker, rules.find(x => x.toCell == cellTracker.id), true);
        //    }
        //  }
        //}




        let children = this.evaluation.submissions.filter(x => x.parentSectionItemColumnDescriptionId == cellTracker.sectionItemColumnDescriptionId);
        if (children != null) {
          children.forEach(function (child) {
            if (cellTracker.selected)
              child.disabled = false;
            else {
              child.disabled = true;
              child.selected = false;
              child.unSelected = false;
            }
            if (!child.unSelected)
              child.cssClassName = child.selected ? "itemCellSelected" : "itemCellActive";
          });

        }

        //if (secCount == 7) {

        this.codingSubmittable = this.executeMasterRule(cellTracker);

        //}

        if (this.codingSubmittable) {
          this.codingSubmittable = this.checkIfConflictsAreCleared();


        }



        //console.log(this.evaluation.submissions)
        //console.log("IsConsensus: " + this.isConsensus);
        //console.log("IsConsensusMerge: " + this.isConsensusMerge);
        if (this.joinedConsensus && (this.isConsensus || this.isConsensusMerge)) {
          var watcherFormTitle = "";
          switch (this.evaluation.abstractStatusId) {
            case AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A:
              watcherFormTitle = "QC Coding Consensus [W2]";
              break;
            case AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B:
              watcherFormTitle = "QC Comparison with ML [W3]";
              break;
            case AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A:
              watcherFormTitle = "Reconcilation Coding Consensus [O2]";
              break;
            case AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B:
              watcherFormTitle = "Reconciliation Comparison with QC-Consensus and ML [O3]";
              break;
          }
          /*this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, this.isConsensusMerge ? "Watching Comparison - Driven by {username}" : "Watching Consensus - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : "");*/
          this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, "Watching " + watcherFormTitle + " - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : "");
        }
        if (this.authService.currentUser) {
          this.authService.resetTimeout();
          console.log("Reset timer manually on action");
        }
      }
    }
  }

  public checkIfConflictsAreCleared(): boolean {
    let result = this.evaluation.submissions.find(x => x.unSelected == true);
    if (result) {
      console.log(result)
      return false;
    }
    else {
      return true;
    }
  }

  public executeRules(cellRules: Array<ProtocolSubmissionRule>, cellTracker: Tracker): boolean {
    let ruleResult = false;
    for (let rule of cellRules) {
      switch (rule.ruleActionType.command) {
        case "ThenEnabled":
          ruleResult = this.executeThenEnabledAction(cellTracker, rule);
          break;
        case "NoOtherInSection":
          ruleResult = this.executeNoOtherInSectionAction(cellTracker, rule);
          break;
        case "And":
          ruleResult = this.executeAndAction(rule);
          break;
        case "NoOtherInForm":
          ruleResult = this.executeNoOtherInFormAction(cellTracker, rule);
          break;
        case "Or":
          ruleResult = this.executeOrAction(rule);
          break;
        case "AtLeastOne":
          ruleResult = this.executeAtLeastOneAction(rule);
          break;
        case "ThenRequired":
          ruleResult = this.executeThenRequiredAction(rule);
          break;
        case "NoOtherInParent":
          ruleResult = this.executeNoOtherInParentAction(cellTracker, rule);
          break;
      }
      ///If any of these rules fail, do not run any more rules. Only a master rule failure can be overridden; all other failures are final.
      if (ruleResult == false) { break; }
    }
    return ruleResult;
  }

  openBottomSheet(sheetTitle: string, sheetText: string): Observable<any> {
    return this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        sheetText: sheetText
      },
      closeOnNavigation: true
    }).afterDismissed();
  }

  public submitCoding() {
    if (!this.submissionProcessing) {
      this.openBottomSheet('Confirm Submission', 'Are you sure you want to submit?').subscribe({
        next: confirmed => {
          if (confirmed) {
            this.submissionProcessing = true;
            let codingSubmission: Evaluation = new Evaluation();
            codingSubmission.abstractId = this.abstractId;
            codingSubmission.protocolId = this.protocolId;
            codingSubmission.abstractProtocolId = this.evaluation.abstractProtocolId;
            codingSubmission.evaluationId = this.evaluation.evaluationId;
            codingSubmission.abstractStatusId = this.evaluation.abstractStatusId;
            codingSubmission.submissionTypeId = this.submissionTypeId;
            codingSubmission.submissions = this.evaluation.submissions;
            codingSubmission.isRecommendedForReview = this.recommendedForODPReview;
            codingSubmission.isRecommendedForAdjudication = this.recommendedForODPAdjudication;


            //console.log('loadCodingUIElements')
            this.alertService.startLoadingMessage();
            this.loadingIndicator = true;

            this.codingService.newCodingSubmission(codingSubmission, this.accountService.GetActiveTeam().teamId)
              .subscribe({
                next: codingSubmission => {
                  this.alertService.stopLoadingMessage();
                  window.scroll(0, 0);
                  this.loadingIndicator = false;
                  this.isSubmitted = true;
                  this.submissionProcessing = false;

                  if (codingSubmission.isConsensusReady) {
                    this.isConsensusReady = true;
                  }

                  if (codingSubmission.isComplete) {
                    this.isEvaluationCompleted = true;
                    //this.isSubmitted = false;
                  }

                  if (codingSubmission.isMergeReady) {
                    this.isConsensusMerge = true;
                    //this.isSubmitted = false;
                  }

                  this.evaluation.formTitle = codingSubmission.formTitle;

                  this.evaluation.watchConsensusVisible = codingSubmission.watchConsensusVisible;
                  this.evaluation.startConsensusVisible = codingSubmission.startConsensusVisible;
                  this.evaluation.startConsensusMergeVisible = codingSubmission.startConsensusMergeVisible;

                  this.evaluation.currentSubmissionId = codingSubmission.currentSubmissionId;

                  if (!this.joinedConsensus)
                    this.joinConsensusPresence();



                  if (this.isConsensus || this.isConsensusMerge) {
                    var watcherFormTitle = "";
                    switch (this.evaluation.abstractStatusId) {
                      case AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A:
                        watcherFormTitle = "QC Coding Consensus [W2]";
                        break;
                      case AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B:
                        watcherFormTitle = "QC Comparison with ML [W3]";
                        break;
                      case AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A:
                        watcherFormTitle = "Reconcilation Coding Consensus [O2]";
                        break;
                      case AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B:
                        watcherFormTitle = "Reconciliation Comparison with QC-Consensus and ML [O3]";
                        break;
                    }
                    /*this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, this.isConsensusMerge ? "Watching Comparison - Driven by {username}" : "Watching Consensus - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : "");*/
                    this.hub.broadcastConsensusState(this.evaluation.evaluationId, this.evaluation.submissions, "Watching " + watcherFormTitle + " - Driven by {username}", this.isSubmitted ? "Coding form submitted successfully." : "");
                  }

                  //     console.log(codingSubmission)
                }, error: (error) => {
                  const errorResult: { message: string, object: { shouldRedirect: boolean, submissionId: number } } = error.error;

                  this.alertService.stopLoadingMessage();
                  this.loadingIndicator = false;
                  this.submissionProcessing = false;

                  const errorObject = {
                    title: 'Load Error',
                    message: `Error occured while trying to add user submission.\r\nErrors: "${Utilities.getHttpResponseMessage(errorResult.message)}"`,
                    error: errorResult.message,
                    severity: MessageSeverity.error
                  };

                  if (errorResult.object.submissionId > 0) {
                    this.router.navigateByUrl('/evaluation/view/' + errorResult.object.submissionId);
                  } else if (errorResult.object.shouldRedirect) {
                    this.errorService.error = errorObject;
                    this.router.navigate(['/home/actions']);
                  } else {
                    this.alertService.showStickyMessage(errorObject.title, errorObject.message, errorObject.severity, errorObject.error);
                  }
                }
              });
          }
        }
      });
    }
    else {
      console.log("Submission already being processed.");
    }
  }
  //QC Notes:
  /// canAddNotes: W2 read/write for ALL users, W3 read/write
  /// canReadNotes: O3 readonly
  canAddNotes() {
    // For QC Coder role: Only allowing QC Coders on the coding team to add notes in consensus/comparison status
    return (((this.activeRole === Roles.QCCoder && this.evaluation.teamId == this.activeTeamId) || this.activeRole === Roles.QCSupervisor) &&
      ((this.evaluation.abstractStatusId === AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A) ||
        (this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B) ||
        (this.evaluation.abstractStatusId === AbstractStatus.MLCOMPARE_COMPLETED_BY_CODERS_1ML) ||
        this.isWatchConsensus));
  }
  canReadNotes() {
    return ((this.activeRole === Roles.ReconciliationCoder ||
      this.activeRole === Roles.ReconciliationSupervisor || this.activeRole === Roles.QCCoder ||
      this.activeRole === Roles.QCSupervisor) &&
      ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B) ||
      (this.evaluation.abstractStatusId === AbstractStatus.ODP_STAFF_AND_CODER_CONSENSUS_MERGED_2C)));
  }

  //QC Coder Question: W2 read/write for consensus driver ONLY, W3 read/write for consensus driver ONLY, O3 readonly
  canRecommendForReview() {
    // Allowing QC Roles to see recommend for review outside of coder coding status
    return (((this.activeRole === Roles.QCCoder || this.activeRole === Roles.QCSupervisor) &&
      !(this.evaluation.abstractStatusId === AbstractStatus.RETRIEVED_FOR_CODING_BY_CODER_1 && !this.isSubmissionView)) ||
      // Allowing Reconciliation Coders and Supervisors to view recommend for review in O3
      ((this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor) && ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B && !this.isSubmissionView) ||
        this.evaluation.submissionTypeId === SubmissionType.OdpWestatComparison)));

    /*return ((((this.activeRole === Roles.QCCoder && this.evaluation.teamId == this.activeTeamId) || this.activeRole === Roles.QCSupervisor) &&
      (((this.evaluation.abstractStatusId === AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A && !this.isSubmissionView) ||
        this.evaluation.submissionTypeId === SubmissionType.CoderConsensus && this.isSubmissionView) ||
        ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B && !this.isSubmissionView) ||
          this.evaluation.submissionTypeId === SubmissionType.CoderMlComparison && this.isSubmissionView))) ||
      ((this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor) && ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B && !this.isSubmissionView) ||
        this.evaluation.submissionTypeId === SubmissionType.OdpWestatComparison)));*/
  }
  //Request ODP Adjudication: W3 read/write for consensus driver ONLY, O3 readonly
  canRecommendForAdjudication() {
    // Allowing QC Roles to see recommend for adjudication outside of coder/consensus coding status
    return (((this.activeRole === Roles.QCCoder || this.activeRole === Roles.QCSupervisor) &&
      (!(this.evaluation.abstractStatusId === AbstractStatus.RETRIEVED_FOR_CODING_BY_CODER_1 && !this.isSubmissionView) &&
      !(this.evaluation.abstractStatusId === AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A && !this.isSubmissionView))) ||
    // Allowing Reconciliation Coders and Supervisors to view recommend for review in O3
      ((this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor) &&
        ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B && !this.isSubmissionView) ||
          this.evaluation.submissionTypeId === SubmissionType.OdpWestatComparison)));
    /*return (((this.activeRole === Roles.QCCoder && this.evaluation.teamId == this.activeTeamId) || this.activeRole === Roles.QCSupervisor) &&
      ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B && !this.isSubmissionView) ||
        this.evaluation.submissionTypeId === SubmissionType.CoderMlComparison && this.isSubmissionView)) ||
      ((this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor) &&
        ((this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B && !this.isSubmissionView) ||
          this.evaluation.submissionTypeId === SubmissionType.OdpWestatComparison));*/
  }
  //Disable QC Coder Question
  disableODPReview() {
    var activeConsensusCoding = (this.evaluation.abstractStatusId === AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A && !this.isSubmissionView);
    var consensusViewing = (this.evaluation.submissionTypeId === SubmissionType.CoderConsensus && this.isSubmissionView);
    var activeComparisonCoding = (this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B && !this.isSubmissionView);
    var comparisonViewing = (this.evaluation.submissionTypeId === SubmissionType.CoderMlComparison && this.isSubmissionView);

    return (this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor ||
    // Not allowing QC Coders that are not on the coding team to recommend for review
      (this.activeRole === Roles.QCCoder && this.evaluation.teamId !== this.activeTeamId)) ||
    // Not allowing QC Roles to recommend for review if the abstract is not in the correct status or if submission type doesn't match
      (((this.activeRole === Roles.QCCoder && this.evaluation.teamId == this.activeTeamId) || this.activeRole === Roles.QCSupervisor) &&
        (!(activeConsensusCoding || consensusViewing) && !(activeComparisonCoding || comparisonViewing)));
  }
  //Disable ODP Adjudication
  disableAdjudication() {
    var activeComparisonCoding = (this.evaluation.abstractStatusId === AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B && !this.isSubmissionView);
    var comparisonViewing = (this.evaluation.submissionTypeId === SubmissionType.CoderMlComparison && this.isSubmissionView);

    return (this.activeRole === Roles.ReconciliationCoder || this.activeRole === Roles.ReconciliationSupervisor ||
    // Not allowing QC Coders that are not on the coding team to recommend for adjudication
      (this.activeRole === Roles.QCCoder && this.evaluation.teamId !== this.activeTeamId)) ||
        // Not allowing QC Roles to recommend for adjudication if the abstract is not in the correct status or if submission type doesn't match
        (((this.activeRole === Roles.QCCoder && this.evaluation.teamId == this.activeTeamId) || this.activeRole === Roles.QCSupervisor) &&
          (!(activeComparisonCoding || comparisonViewing)));
  }

  public recommendForReview(currentEvaluationId: number) {
    if (currentEvaluationId != null && currentEvaluationId != 0) {

      this.codingService.recommendEvaluationForReview(currentEvaluationId)
        .subscribe({
          next: result => {
            this.alertService.showMessage("Saved!", '"QC Coder Question" option changed.', MessageSeverity.warn);
          }, error: (error) => {
            this.alertService.showStickyMessage("System was not able to process request", `"${Utilities.getHttpResponseMessage(error.error.error)}"`,
              MessageSeverity.error, error);
          }
        });
    }
    else {
      //this.recommendedForODPReview = !this.recommendedForODPReview;
      console.log(this.recommendedForODPReview);
    }
  }

  public recommendForAdjudication(currentEvaluationId: number) {
    if (currentEvaluationId != null && currentEvaluationId != 0) {

      this.codingService.recommendEvaluationForAdjudication(currentEvaluationId)
        .subscribe({
          next: result => {
            this.alertService.showMessage("Saved!", '"Request ODP Adjudication" option changed.', MessageSeverity.warn);
          }, error: (error) => {
            this.alertService.showStickyMessage("System was not able to process request", `"${Utilities.getHttpResponseMessage(error.error.error)}"`,
              MessageSeverity.error, error);
          }
        });
    }
    else {
      //this.recommendedForODPReview = !this.recommendedForODPReview;
      console.log(this.recommendedForODPAdjudication);
    }
  }
  public executeThenRequiredAction(rule: ProtocolSubmissionRule): boolean {

    let result = true;

    for (let thisfrom of rule.fromCell.split(',')) {
      let ifcell = this.evaluation.submissions.find(x => x.id == thisfrom.trim());
      if (ifcell.selected) {
        result = false;
        for (let thisto of rule.toCell.split(',')) {
          let thencell = this.evaluation.submissions.find(x => x.id == thisto.trim());
          if (thencell.selected == true) {
            result = true;
            return result;
          }
        }
      } else {
        return result;
      }
    }
    return result;
  }

  public executeThenEnabledAction(cellTracker: Tracker, rule: ProtocolSubmissionRule, inverse: boolean = false): boolean {

    if (!inverse) {
      if (rule.fromCell === cellTracker.id) {
        const affected = this.evaluation.submissions.find(x => x.id === rule.toCell);

        if (cellTracker.selected) {
          affected.disabled = false;

          if (!affected.unSelected) {
            affected.selected = false;
            affected.cssClassName = 'itemCellActive';
            this.alertService.showMessage('Rule triggered',
              `Cell: ${affected.id} has been re-enabled since cell: ${cellTracker.id} has been selected.`, MessageSeverity.warn);
          }

          return;
        } else {
          affected.disabled = true;
          affected.selected = false;
          affected.unSelected = false;
          affected.cssClassName = 'itemCellDisabled';

          let children = this.evaluation.submissions.filter(x => x.parentSectionItemColumnDescriptionId == affected.sectionItemColumnDescriptionId);
          if (children != null) {
            children.forEach(function (child) {
              child.disabled = true;
              child.selected = false;
              child.unSelected = false;
              child.cssClassName = child.selected ? "itemCellSelected" : "itemCellActive";
            });

          }

          this.alertService.showMessage('Rule triggered',
            `Cell: ${affected.id} has been disabled since cell: ${cellTracker.id} has been de-selected.`, MessageSeverity.warn);
        }
      }
    }
    else {
      if (rule.toCell == cellTracker.id) {
        let affected = this.evaluation.submissions.find(x => x.id == rule.fromCell);
        if (!affected.selected) {
          cellTracker.disabled = true;
          cellTracker.selected = false;
          cellTracker.cssClassName = "itemCellDisabled";
          this.alertService.showMessage("Rule triggered", "Cell: " + rule.toCell + " can not be selected if cell: " + rule.fromCell + " hasn't been selected.", MessageSeverity.warn);
          return;
        }
        else {
          return;
        }
      }
      else {
        return;
      }

    }
  }

  public executeNoOtherInSectionAction(cellTracker: Tracker, rule: ProtocolSubmissionRule): boolean {

    let affectedList = this.evaluation.submissions.filter(x => x.id.substring(0, 1) == rule.toCell);
    for (let affected of affectedList) {
      if (affected.id != cellTracker.id) {
        affected.disabledByRule = cellTracker.selected ? true : false;
        affected.disabledByRuleId = cellTracker.selected ? rule.id : null;
        affected.cssClassName = affected.disabledByRule ? "itemCellDisabled" : "";
        affected.selected = false;
        affected.unSelected = false;
        //this.reTraceTrackerForRules();
      }
    }
    return true;
  }


  public executeNoOtherInParentAction(cellTracker: Tracker, rule: ProtocolSubmissionRule): boolean {

    let childrenList = this.evaluation.submissions.filter(x => x.parentSectionItemColumnDescriptionId == cellTracker.parentSectionItemColumnDescriptionId);
    if (childrenList != null) {
      for (let child of childrenList) {
        if (child.id != cellTracker.id) {
          child.disabledByRule = cellTracker.selected ? true : false;
          child.disabledByRuleId = cellTracker.selected ? rule.id : null;
          child.cssClassName = child.disabledByRule ? "itemCellDisabled" : "";
          child.selected = false;
          child.unSelected = false;
          //this.reTraceTrackerForRules();
        }
      }
    }


    return true;
  }

  public executeAndAction(rule: ProtocolSubmissionRule): boolean {

    for (let tracker of this.evaluation.submissions) {
      if (tracker.selected == true && (tracker.id != rule.fromCell && tracker.id != rule.toCell))
        return false;
    }
    var from = this.evaluation.submissions.find(t => t.id == rule.fromCell);
    var to = this.evaluation.submissions.find(t => t.id == rule.toCell);
    if (from != null && from.selected == true && to != null && to.selected == true)
      return true;
    return false;

  }

  public executeMasterRule(tracker: Tracker) {
    let result = true;
    //var masterRule = this.evaluation.protocolSubmissionRules.find(psr => psr.description == 'Master');
    var masterRule = this.evaluation.protocolSubmissionRules.find(psr => psr.ruleActionType.decription == 'Master');
    if (masterRule != null) {
      for (let section of masterRule.toCell.split(',')) {
        if (this.evaluation.submissions.filter(t => t.selected == true && (t.id.substring(0, 2) == section.trim() || t.id.substring(0, 1) == section.trim())).length < 1) {
          result = false;
          break;
        }
      }
      if (!result) {
        var runIfFailRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.runsIfRuleFailId == masterRule.id);
        if (runIfFailRules.length > 0) {
          result = this.executeRules(runIfFailRules, tracker);
        }
      }
      else if (result) {
        var runIfSuccedRules = this.evaluation.protocolSubmissionRules.filter(psr => psr.runsIfRuleSuccedId == masterRule.id);
        if (runIfSuccedRules.length > 0) {
          result = this.executeRules(runIfSuccedRules, tracker);
        }
      }
    }
    return result;
  }

  public executeNoOtherInFormAction(cellTracker: Tracker, rule: ProtocolSubmissionRule): boolean {

    var otherXselected = false;
    let otherX = this.evaluation.submissions.filter(x => (x.id.substring(0, 1) == cellTracker.id.substring(0, 1)) && (x.id != cellTracker.id));
    if (otherX.length > 0) {
      for (let x of otherX) {
        if (x.selected == true) {
          otherXselected = true;
          break
        }
      }
    }
    if (otherXselected == false) {
      for (let section of rule.toCell.split(',')) {
        let affectedList = this.evaluation.submissions.filter(x => x.id.substring(0, 1) == section.trim());
        for (let affected of affectedList) {
          if (affected.id != cellTracker.id) {
            affected.disabledByRule = cellTracker.selected ? true : false;
            affected.disabledByRuleId = cellTracker.selected ? rule.id : null;
            affected.cssClassName = affected.disabledByRule ? "itemCellDisabled" : "";
            affected.selected = false;
            affected.unSelected = false;
          }
        }
      }
    }
    return true;
  }

  public executeOrAction(rule: ProtocolSubmissionRule): boolean {

    var from = this.evaluation.submissions.find(t => t.id == rule.fromCell);
    var to = this.evaluation.submissions.find(t => t.id == rule.toCell);
    if ((from != null && from.selected == true) || (to != null && to.selected == true))
      return true;
    return false;

  }

  public executeAtLeastOneAction(rule: ProtocolSubmissionRule): boolean {

    let result = false;

    for (let item of rule.toCell.split(',')) {
      let affectedList = this.evaluation.submissions.filter(x => x.id == item.trim());
      for (let affected of affectedList) {
        if (affected.selected == true) {
          result = true;
          return result;
        }
      }
    }
    return result;
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(QuickNoteDialogComponent, {
      width: '450px',
      data: {
        noteText: this.noteText,
        notes: this.evaluation.notes,
        currentPhase: (this.canRecommendForAdjudication() || this.canRecommendForReview()) ? "O3" : "",
        noteReadOnly: this.canReadNotes()
        // W phase can see and add notes. O phase can only see notes in O3
        // 9/9 AP switching this to use the same logic for displaying checkboxes in O3
        // temporarily while I figure out why the phases aren't updated as expected.
      }
    });

    dialogRef.componentInstance.addNote.subscribe({
      next: (result: string) => {
        if (result !== null && result.trim() !== '') {
          this.note.notePlain = result;
          this.note.abstractProtocolID = this.evaluation.abstractProtocolId;
          this.note.evaluationID = this.evaluation.evaluationId;

          this.noteService.addNote(this.note)
            .subscribe({
              next: note => {
                this.alertService.showMessage('Note', `Saved!`, MessageSeverity.success);
                this.evaluation.notes.unshift(note);
              }, error: (err) => {
                this.alertService.showStickyMessage(
                  'Save Error',
                  `Unable to save the note.\r\nIf error persist, please contact IT.\r\nErrors: "${Utilities.getHttpResponseMessage(err)}"`,
                  MessageSeverity.error, err);
              }
            });
        }
      }
    });
  }

  openDecisionBottomSheet(sheetTitle: string, sheetText: string) {
    return this.bottomSheet.open(DecisionBottomSheetComponent, {
      data: {
        sheetTitle: sheetTitle,
        sheetText: sheetText
      },
      closeOnNavigation: true
    }).afterDismissed();
  }

  public toggleCollapseSection(sectionId: number) {
    let section = this.evaluation.codingUISections.find(x => x.id == sectionId);
    section.isCollapsed = !section.isCollapsed;
  }

  //get fullName(): string {
  //  return this.authService.currentUser ? this.authService.currentUser.fullName : "";
  //}

  evaluatePhase() {

    let abstractStatusId = this.evaluation.abstractStatusId;
    switch (abstractStatusId) {
      case AbstractStatus.UPLOADED_INTO_THE_SYSTEM_0:
      case AbstractStatus.RETRIEVED_FOR_CODING_BY_CODER_1: {
        this.currentPhase = "W1";
        this.isDriving = false;
      }
        break;
      case AbstractStatus.READY_FOR_CONSENSUS_BY_CODERS_1A: {
        this.currentPhase = "W2";
        this.isDriving = true;
      }
        break;
      case AbstractStatus.CONSENSUS_COMPLETE_NOTES_UPLOADED_BY_CODERS_1N: {
        this.currentPhase = "W2";
        this.isDriving = false;
      }
        break;
      case AbstractStatus.CONSENSUS_COMPLETED_BY_CODERS_1B: {
        this.currentPhase = "W3";
        this.isDriving = true;
      }
        break;
      case AbstractStatus.MLCOMPARE_COMPLETED_BY_CODERS_1ML: {
        this.currentPhase = "W3";
        this.isDriving = false;
      }
        break;
      case AbstractStatus.RETRIEVED_FOR_CODING_BY_ODP_STAFF_2: {
        this.currentPhase = "O1";
        this.isDriving = false;
      }
        break;
      case AbstractStatus.READY_FOR_CONSENSUS_BY_ODP_STAFF_2A: {
        this.currentPhase = "O2";
        this.isDriving = true;
      }
        break;
      case AbstractStatus.CONSENSUS_COMPLETED_BY_ODP_STAFF_2B: {
        this.currentPhase = "O2";
        this.isDriving = false;
      }
        break;
      case AbstractStatus.ODP_STAFF_AND_CODER_CONSENSUS_MERGED_2C: {
        this.currentPhase = "O3";
        this.isDriving = true;
      }
        break;
      case AbstractStatus.CONSENSUS_COMPLETE_NOTES_UPLOADED_BY_ODP_STAFF_2N: {
        this.currentPhase = "O3";
        this.isDriving = false;
      }
        break;
      default: {
        this.currentPhase = "";
        this.isDriving = null;
      }
        break;
    }
  }
}
